import React from "react";

function ChecklistStepCard(props) {
    const { step, type, total, title } = { ...props };
    return (
        <div className="slider-card center">
            <h4>ROLES</h4>
            <h3>{title}</h3>
            {parseInt(step.step_number) < total &&
                <p className="next-step">Swipe for next step</p>
            }
            <div>
                <h6>CHECKLIST</h6>
                <p>{type}</p>
                <h6>STEP</h6>
                <p>{step.step_number} OF {total}</p>
                <h6>TASK</h6>
                <div dangerouslySetInnerHTML={{__html: step.task}}></div>
            </div>
        </div>
    )
}

export default ChecklistStepCard;